<template>
  <section
    v-on="$listeners"
    class="dash-crypto card"
    >
    <div class="dash-crypto__header">
      <Icon
        :icon="coin.title"
        class="dash-crypto__icon"
        />

      <div class="dash-crypto__info">
        <h1
          :style="title_style"
          class="dash-crypto__title"
          >
          {{ coin.title.toUpperCase() }}

          <Percent :value="coin.percent" />
        </h1>
        <p class="dash-crypto__description">
          {{ coin.formated }}

          <span class="dash-crypto__initial" v-text="coin.initial"></span>
        </p>
      </div>
    </div>

    <div class="dash-crypto__container">
      <ApexChart width="100%" height="86" type="area" :options="options" :series="series" />
    </div>
  </section>
</template>

<script>
  import Icon from '@/components/Icon';
  import ApexChart from 'vue-apexcharts';
  import Percent from '@/components/Percent';
  import { format, createChartArray } from '@/helpers';

  export default {
    components: {
      Icon,
      Percent,
      ApexChart,
    },

    props: {
      coin: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      values: [0, 0],
    }),

    mounted () {
      createChartArray(this.coin.total, 13, 12 * 60 * 60 * 1000)
        .then(values => this.values = values);
    },

    computed: {
      percent_abs () {
        return Math.abs(this.coin.percent);
      },

      title_style () {
        return {
          color: this.coin.color,
        };
      },

      series () {
        return [{
          data: this.values,
        }];
      },

      options () {
        return {
          chart: {
            toolbar: {
              show: false,
            },

            sparkline: {
              enabled: true,
            },

            animations: {
              enabled: false,
              easing: 'linear',
              dynamicAnimation: {
                speed: 500
              }
            },
          },

          dataLabels: {
            enabled: false,
          },

          markers: {
            size: 0,
            colors: [
              this.coin.color,
            ],
            strokeWidth: 10,
            strokeOpacity: 0.2,
            strokeColor: this.coin.color,
            hover: {
              size: 5,
            },
          },

          legend: {
            show: false,
            enabled: false,
          },

          grid: {
            show: false,
            dataLabels: {
              enabled: false,
            },

            legend: {
              show: false,
            },

            padding: {
              top: 0,
              left: 24,
              right: 24,
              bottom: 24,
            },
          },

          stroke: {
            width: 2.5,
            colors: [
              this.coin.color,
            ],
            curve: 'straight',
          },

          tooltip: {
            theme: false,

            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              const price = format(series[seriesIndex][dataPointIndex]);
              const day = new Date(this.series[0].data[dataPointIndex][0]);

              return `<div class="chart-crypto__label"><span class="chart-crypto__price">${price}</span> ${day.toLocaleString('pt-BR')}</div>`;
            },
          },

          fill: {
            colors: [
              this.coin.color,
            ],

            gradient: {
              colorStops: [
                {
                  offset: 0,
                  opacity: .2,
                  color: this.coin.color,
                },
                {
                  offset: 100,
                  opacity: 0,
                  color: this.coin.color,
                },
              ],
            },
          },

          yaxis: {
            show: false,
            enabled: false,

            lines: {
              show: false,
            },

            axisBorder: {
              show: false,
            },
          },

          xaxis: {
            show: false,
            enabled: false,

            lines: {
              show: false,
            },

            axisBorder: {
              show: false,
            },

            labels: {
              show: false,
            },

            tooltip: {
              enabled: false,
            },
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  .dash-crypto {
    height: 181px;
    display: flex;
    cursor: pointer;
    position: relative;
    flex-direction: column;
    justify-content: space-between;

    &__header {
      height: 36px;
      display: flex;
      padding: 24px 24px 0 24px;
    }

    &__icon {
      width: 33px;
      height: 36px;
      margin-top: 2px;
      margin-right: 16px;
    }

    &__info {
      flex: 1;
    }

    &__title {
      display: flex;
      font-size: 14px;
      line-height: 1.14;
      margin-bottom: 6px;
      align-items: flex-start;
      justify-content: space-between;
    }

    &__description {
      display: flex;
      line-height: 1;
      font-size: 20px;
      margin-top: -1px;
      color: #FFFFFF;
      font-weight: 300;
      align-items: center;
      justify-content: space-between;
    }

    &__initial {
      font-size: 13px;
      color: #b2b8c5;
      font-weight: 400;
      line-height: 0.77;
    }
  }
</style>
